import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getApplicationNoticePreview = async (orderApplicationId, distributionLists) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/oa-notice-preview`, {
		order_application_id: String(orderApplicationId),
		distribution_lists: distributionLists,
	});
	return data;
};

export const sendApplicationNotice = async (orderApplicationId, distributionLists) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/send-oa-notice`, {
		order_application_id: String(orderApplicationId),
		distribution_lists: distributionLists,
	});
	return data;
};
